import { CircularProgress, CircularProgressProps, IconButton, SxProps, Theme } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

interface RefreshIconWithLoaderProps {
  showLoader: boolean;
  onRefresh: () => void;
  loaderProps?: CircularProgressProps;
  iconButtonStyle?: SxProps<Theme>;
}
const RefreshIconWithLoader: React.FC<RefreshIconWithLoaderProps> = ({
  showLoader,
  onRefresh,
  loaderProps,
  iconButtonStyle,
}) => {
  if (showLoader)
    return (
      <CircularProgress color={'secondary'} size={20} sx={{ margin: '10px' }} {...loaderProps} />
    );
  return (
    <IconButton
      disableFocusRipple
      disableRipple
      disableTouchRipple
      onClick={onRefresh}
      sx={{ color: '#2E736E', ...iconButtonStyle }}
    >
      <RefreshIcon />
    </IconButton>
  );
};

export default RefreshIconWithLoader;
